<template>
<div class="button-group">
	<div class="item-list">
		<div class="item"
			:class="activeButton == 0 ? 'active' : ''"
		>
			<button @mouseover="toggle(0)">
				<i class="icon-at"></i>
			</button>
			<div class="name">
				Add to favourites
			</div>
		</div>

		<div class="item"
			:class="activeButton == 1 ? 'active' : ''"
		>
			<button @mouseover="toggle(1)">
				<i class="icon-check"></i>
			</button>
			<div class="name">
				Add to favourites
			</div>
		</div>

		<div class="item"
			:class="activeButton == 2 ? 'active' : ''"
		>
			<button @mouseover="toggle(2)">
				<i class="icon-exchange"></i>
			</button>
			<div class="name">
				Add to favourites
			</div>
		</div>

		<div class="item default-active"
			:class="activeButton == 3 ? 'active' : ''"
		>
			<button @mouseover="toggle(3)">
				<i class="icon-plus"></i>
			</button>
			<div class="name">
				Add to favourites
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	data: () => ({
		activeButton: 3
	}),
	methods: {
		toggle(index) {
			this.activeButton = index
		}
	}
}
</script>

<style lang="scss">
.button-group {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 25px;
	overflow: hidden;

	.item-list {
		width: 500px;
		float: right;
	}
	.item {
		float: right;

		.name {
			float: right;
			width: 0px;
			line-height: 55px;
			color: #fff;
			background: #4ba98b;
			font-size: 12px;
			cursor: pointer;
			transition: all 0.1s linear;
			white-space: nowrap;
			overflow: hidden;
		}
		button {
			float: right;
			width: 35.25px;
			line-height: 55px;
			padding: 0;
			border: none;
			border-radius: 0;
			font-size: 22px;
			background-color: #3b9fcf;
			color: #fff;
			cursor: pointer;
			user-select: none;
			outline: none;
		}

		&:not(:first-child) {
			button {
				margin-right: 1px;
			}
		}
	}
	.item.default-active {
		.name {
			width: 151px;
		}
	}
	.item.active {
		button {
			background: #4ba98b;
			margin-left: 1px;
		}
		.name {
			width: 151px;
		}
	}
}
</style>
